<!-- Search Filter End -->
<div class="row search-result-count mx-0" *ngIf="dataLoaded">
    <!--|| filterSelected-->
    <div class="col-12 mt-4">
        <p class="font-bold mb-0">
            {{getCount()}} Result(s)
        </p>
    </div>
</div>

<ng-container *ngIf="searchResult.length >0">
    <div class="d-flex search-result pl-3">
        <div class="col-5 panel-left">
            <ng-container *ngFor="let searchItem of searchResult; let i = index">
                <div *ngIf="searchItem['_index'] !== 'cfprojects'" class="row align-items-center search-result-row"
                    [class.active]="clicked === searchItem">
                    <div class="col-9 pl-2">
                        <h2 class="text-truncate">
                            <button type="button" class="btn btn-clear" *ngIf="searchItem['_index'] === 'cfdocument'"
                                (click)="onTreeNodeSelected(searchItem);clicked = searchItem" id="{{ 'a-tag' + i }}">
                                <span [mathJax]="searchItem._source.title ? searchItem._source.title : ''">
                                </span>
                            </button>
                            <button type="button" class="btn btn-clear" *ngIf="searchItem['_index'] === 'cfitems'"
                                (click)="onTreeNodeSelected(searchItem);clicked = searchItem" id="{{ 'a-tag' + i }}">
                                <ng-container *ngIf="searchItem._source.humanCodingScheme">
                                    <span
                                        [mathJax]="searchItem._source.humanCodingScheme? searchItem._source.humanCodingScheme + ' ':''">
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="searchItem._source.fullStatement">
                                    <span
                                        [mathJax]="searchItem._source.fullStatement ? searchItem._source.fullStatement : ''">
                                    </span>
                                </ng-container>
                            </button>
                            <button type="button" class="btn btn-clear"
                                *ngIf="searchItem['_index'] === 'cfassociations'"
                                (click)="onTreeNodeSelected(searchItem);clicked = searchItem" id="{{ 'a-tag' + i }}">
                                <ng-container *ngIf="searchItem._source.originNodeURI.title">
                                    <span
                                        [mathJax]="searchItem._source.originNodeURI.title ? searchItem._source.originNodeURI.title : ''">
                                    </span>
                                </ng-container>
                            </button>
                        </h2>
                    </div>
                    <div class="col-3" *ngIf="searchItem['_index'] === 'cfitems'">
                        <p class="mb-0 grade text-truncate">
                            {{searchItem._source.CFItemTypeURI.title}}
                        </p>
                    </div>
                </div>
            </ng-container>
            <button *ngIf="searchResult?.length < totalSearchResults" id="loadMoreButton"
                class="btn btn-showMore d-flex align-items-center px-1 position-relative border-0"
                (click)="loadMoreList()">
                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" aria-hidden="true"
                    class="icon mr-2 position-relative">
                    <path
                        d="M4.958 11.625Q4.292 11.625 3.812 11.146Q3.333 10.667 3.333 10Q3.333 9.333 3.812 8.854Q4.292 8.375 4.958 8.375Q5.625 8.375 6.104 8.854Q6.583 9.333 6.583 10Q6.583 10.667 6.104 11.146Q5.625 11.625 4.958 11.625ZM10 11.625Q9.333 11.625 8.854 11.146Q8.375 10.667 8.375 10Q8.375 9.333 8.854 8.854Q9.333 8.375 10 8.375Q10.667 8.375 11.146 8.854Q11.625 9.333 11.625 10Q11.625 10.667 11.146 11.146Q10.667 11.625 10 11.625ZM15.042 11.625Q14.375 11.625 13.896 11.146Q13.417 10.667 13.417 10Q13.417 9.333 13.896 8.854Q14.375 8.375 15.042 8.375Q15.708 8.375 16.188 8.854Q16.667 9.333 16.667 10Q16.667 10.667 16.188 11.146Q15.708 11.625 15.042 11.625Z" />
                </svg>
                <span class="sr-only">
                    {{pagination}} nodes
                </span>
                <span class="info position-relative">
                    Show more
                </span>
            </button>
        </div>

        <div class="col-7 panel-right project-authoring">
            <div class="node-detail mb-3" *ngIf="currentItem!==null">
                <div class="node-detail-row">
                    <div class="col-12 node-view position-relative">
                        <p class="label mb-0 font-bold">Taxonomy:</p>
                        <p *ngIf="currentItem['_index'] === 'cfitems'" class="mb-0 text-truncate"
                            [mathJax]="currentItem._source.CFDocumentURI.title?currentItem._source.CFDocumentURI.title:''">
                        </p>
                        <p *ngIf="currentItem['_index'] === 'cfdocument'" class="mb-0 text-truncate"
                            [mathJax]="currentItem._source.CFPackageURI.title?currentItem._source.CFPackageURI.title:''">
                        </p>
                        <button class="btn btn-default node-view-button position-absolute" aria-label="Taxonomy Detail"
                            (click)="navigate(currentItem)" *ngIf="!blankNodeType">
                            <span class="material-icons-outlined font-4x" aria-hidden="true">
                                east
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="project-authoring__taxonomyEdit">
                <app-item-details #itemDetailsComponent [isEditable]="false" [view]="view" [showNodeType]="true"
                    [taxonomyData]="taxonomyData" [showAssociation]="showAssocciation" [treeTaxonomyData]="taxonomyData"
                    [showAdditionalMetadata]="showAdditionalMetadata" [showExemplar]="showExemplar"
                    [showDocument]="showDocument" [addedAdditionalMetadata]="itemAdditionalMetadata"
                    [itemExemplars]="itemExemplars" [itemAssets]="itemAssets" [itemAssociations]="itemAssociations">
                </app-item-details>
            </div>
        </div>
    </div>
</ng-container>